import {Component, Input} from '@angular/core';

@Component({
  selector: 'ms-last-activity-widget',
  imports: [],
  templateUrl: './last-activity-widget.component.html',
  styleUrl: './last-activity-widget.component.scss'
})
export class LastActivityWidgetComponent {

  @Input() title: string = '';

  constructor() {
  }

}
